const extractServerErrorMessage = (reportErrors: unknown): string | null => {
  if (!reportErrors || typeof reportErrors !== 'object') {
    return null;
  }

  const payload = 'body' in reportErrors && reportErrors.body && typeof reportErrors.body === 'object'
    ? reportErrors.body as Record<string, unknown>
    : reportErrors as Record<string, unknown>;

  // Common error message field names
  const MESSAGE_FIELDS = ['message', 'error', 'detail', 'text', 'token'];

  // For 400 errors, look for any object key that contains an array of errors
  const errorKeys = Object.keys(payload);

  // Check for arrays of errors
  const errorArrayKey = errorKeys.find(key => {
    const value = payload[key];

    if (Array.isArray(value) && value.length > 0) {
      const firstError = value[0];
      if (typeof firstError === 'string') {
        return true;
      }
      // If the array contains objects, try to extract a message
      if (typeof firstError === 'object' && firstError !== null) {
        const errorObj = firstError as Record<string, unknown>;
        // Check for direct string fields
        if (MESSAGE_FIELDS.some(field => typeof errorObj[field] === 'string')) {
          return true;
        }
        // Check for nested arrays of error messages (e.g., {"name": ["error message"]})
        return Object.values(errorObj).some(entryValue =>
          Array.isArray(entryValue) && entryValue.length > 0 && typeof entryValue[0] === 'string'
        );
      }
    }
    return false;
  });

  const errorArrayIsPresent = !!errorArrayKey;

  if (errorArrayIsPresent) {
    const value = payload[errorArrayKey!];
    if (Array.isArray(value) && value.length > 0) {
      const firstError = value[0];
      if (typeof firstError === 'string') {
        return firstError;
      }
      if (typeof firstError === 'object' && firstError !== null) {
        const errorObj = firstError as Record<string, unknown>;
        // Check for direct string fields first
        const foundField = MESSAGE_FIELDS.find(field => typeof errorObj[field] === 'string');
        if (foundField) {
          return errorObj[foundField] as string;
        }
        // Check for nested arrays of error messages (e.g., {"name": ["error message"]})
        const nestedArrayEntry = Object.entries(errorObj).find(([, entryValue]) =>
          Array.isArray(entryValue) && entryValue.length > 0 && typeof entryValue[0] === 'string'
        );
        if (nestedArrayEntry) {
          const [, errorArray] = nestedArrayEntry;
          if (Array.isArray(errorArray) && errorArray.length > 0 && typeof errorArray[0] === 'string') {
            return errorArray[0] as string;
          }
        }
      }
    }
  }
  
  // Also check for direct string values in common error fields
  const stringError = errorKeys.find(key => {
    const value = payload[key];
    return typeof value === 'string' && value.trim().length > 0 && MESSAGE_FIELDS.includes(key);
  });

  if (stringError) {
    return payload[stringError] as string;
  }

  return null;
};

export default extractServerErrorMessage;
